import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchUserHistoryForEntitlementQueryPPC } from '../../../queries/fetch-user-history-for-entitlement-ppc';

interface UseFetchUserHistoryForEntitlementPPCQueryVariables {
  entitlementId: string;
  transactionAccountId: string;
  highestUsageParentEntitlementId: string;
}

export const useFetchUsageHistoryForEntitlementPPCQuery = ({
  entitlementId,
  transactionAccountId,
  highestUsageParentEntitlementId,
}: UseFetchUserHistoryForEntitlementPPCQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchUserHistoryForEntitlementPpcQuery,
    generatedTypesNew.FetchUserHistoryForEntitlementPpcQueryVariables
  >(fetchUserHistoryForEntitlementQueryPPC, {
    variables: {
      id: entitlementId,
      filterOptions: [
        {
          key: 'pageSize',
          value: '100',
        },
        {
          key: 'parentEntitlementId',
          value: highestUsageParentEntitlementId,
        },
      ],
      transactionAccountId,
    },
    skip: !entitlementId,
    client: ansClient,
  });
};
